import React from 'react'
import styled from 'styled-components'

export const SlackIcon = props => (
  <svg
    id="SlackIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    width="20"
    height="20"
    aria-label="Slack"
    {...props}
  >
    <path
      d="M21.902.148c-3.299 0-5.973 2.68-5.973 5.985a5.979 5.979 0 0 0 5.973 5.985h5.974V6.133A5.98 5.98 0 0 0 21.902.148m0 15.96H5.973C2.674 16.108 0 18.788 0 22.094c0 3.305 2.674 5.985 5.973 5.985h15.93c3.298 0 5.973-2.68 5.973-5.985 0-3.306-2.675-5.986-5.974-5.986"
      fill="#36C5F0"
    />
    <path
      d="M59.734 22.094c0-3.306-2.675-5.986-5.974-5.986-3.299 0-5.973 2.68-5.973 5.986v5.985h5.973a5.98 5.98 0 0 0 5.974-5.985m-15.929 0V6.133A5.98 5.98 0 0 0 37.831.148c-3.299 0-5.973 2.68-5.973 5.985v15.96c0 3.307 2.674 5.987 5.973 5.987a5.98 5.98 0 0 0 5.974-5.985"
      fill="#2EB67D"
    />
    <path
      d="M37.831 60a5.98 5.98 0 0 0 5.974-5.985 5.98 5.98 0 0 0-5.974-5.985h-5.973v5.985c0 3.305 2.674 5.985 5.973 5.985m0-15.96h15.93c3.298 0 5.973-2.68 5.973-5.986a5.98 5.98 0 0 0-5.974-5.985H37.831c-3.299 0-5.973 2.68-5.973 5.985a5.979 5.979 0 0 0 5.973 5.985"
      fill="#ECB22E"
    />
    <path
      d="M0 38.054a5.979 5.979 0 0 0 5.973 5.985 5.98 5.98 0 0 0 5.974-5.985v-5.985H5.973C2.674 32.069 0 34.749 0 38.054m15.929 0v15.96c0 3.306 2.674 5.986 5.973 5.986a5.98 5.98 0 0 0 5.974-5.985V38.054a5.979 5.979 0 0 0-5.974-5.985c-3.299 0-5.973 2.68-5.973 5.985"
      fill="#E01E5A"
    />
  </svg>
)

export default styled(SlackIcon)`
  margin-right: 8px;
`
